import { Col, DatePicker, Divider, Form, Input, Row } from 'antd'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Icon } from '../../../../components'

const { TextArea } = Input

const Address = ({ form, initialValues }) => {
  const isViewMode = !initialValues.active
  const defaultValues = [
    initialValues.on_map_from ? dayjs(initialValues.on_map_from) : null,
    initialValues.on_map_until ? dayjs(initialValues.on_map_until) : null,
  ]
  const [isOnMap, setIsOnMap] = useState(!!initialValues.on_map_from || false)

  const setFormDates = (dates, stringDates) => {
    setIsOnMap(stringDates ? !!stringDates[0] : false)

    form.setFieldsValue({
      on_map_from: stringDates ? stringDates[0] : null,
      on_map_until: stringDates ? stringDates[1] : null,
    })
  }

  const onPaste = (e) => {
    setTimeout(() => {
      const onPasteValue = e.target.value

      if (isEmpty(onPasteValue) || !onPasteValue.includes(',')) return

      const lat = onPasteValue.split(',')[0]?.trim()
      const lng = onPasteValue.split(',')[1]?.trim()

      form.setFieldsValue({
        latitude: lat,
        longitude: lng,
      })
    }, 10)
  }

  return (
    <Row style={{ margin: 15 }}>
      <Col span={24}>
        <Form.Item label="State" name="state">
          <Input disabled={isViewMode} />
        </Form.Item>

        <Form.Item label="City" name="city">
          <Input disabled={isViewMode} />
        </Form.Item>

        <Form.Item label="Zip code" name="zip_code">
          <Input disabled={isViewMode} />
        </Form.Item>

        <Form.Item label="Address Line" name="address_line">
          <Input disabled={isViewMode} />
        </Form.Item>
      </Col>

      <Divider>Map</Divider>

      <Col span={11}>
        <Form.Item label="On map from" name="dates">
          <DatePicker.RangePicker
            allowEmpty={[false, true]}
            defaultValue={defaultValues}
            onChange={setFormDates}
            placeholder={['On map from', 'On map until']}
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          label="Display Name"
          name="display_name"
          rules={[{ message: 'Please set display name', required: isOnMap }]}
          tooltip={{ icon: <Icon type="infoCircle" />, title: 'This name will be displayed on the map.' }}
        >
          <Input />
        </Form.Item>
      </Col>

      <Col span={11}>
        <Form.Item
          label="GPS lat"
          name="latitude"
          normalize={(value) => value.replaceAll(' ', '')}
          rules={[
            { message: 'Please set GPS latitude value', required: isOnMap },
            () => ({
              validator(_, value) {
                return (!value || value.toString().length >= 10) ? Promise.resolve() : Promise.reject(new Error('GPS Latitude must be at least 10 characters for accuracy.'))
              },
            }),
          ]}
          tooltip={{ icon: <Icon type="infoCircle" />, title: 'Right-click your store on Google Maps and click the coordinates to copy.' }}
        >
          <Input onPaste={onPaste} />
        </Form.Item>
      </Col>

      <Col offset={2} span={11}>
        <Form.Item
          label="GPS long"
          name="longitude"
          normalize={(value) => value.replaceAll(' ', '')}
          rules={[
            { message: 'Please set GPS longitude value', required: isOnMap },
            () => ({
              validator(_, value) {
                return (!value || value.toString().length >= 10) ? Promise.resolve() : Promise.reject(new Error('GPS Longitude must be at least 10 characters for accuracy.'))
              },
            }),
          ]}
          tooltip={{ icon: <Icon type="infoCircle" />, title: 'Right-click your store on Google Maps and click the coordinates to copy.' }}
        >
          <Input onPaste={onPaste} />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          label="Details"
          name="map_details"
          tooltip={{ icon: <Icon type="infoCircle" />, title: 'Enter hours or return instructions displayed when customers click the pin.' }}
        >
          <TextArea />
        </Form.Item>
      </Col>
    </Row>
  )
}

Address.propTypes = {
  form: PropTypes.object,
  initialValues: PropTypes.object,
}

export default Address
